export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-dark">
      
      <div className="flex flex-col items-center gap-6">
        
        <img
          src="/logo-horizontal.png"
          alt="SunuMarket"
          className="w-48 md:w-64 animate-fade-in 
                     dark:invert dark:hue-rotate-180 dark:saturate-150 dark:brightness-105"
        />

        {/* Barre de chargement */}
        <div className="w-48 h-1 bg-gray-300 dark:bg-gray-700 rounded-full overflow-hidden">
          <div className="h-full bg-primary-500 animate-loading-bar"></div>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-400 animate-fade-in">
          Chargement...
        </p>

      </div>
    </div>
  );
}